function StartSearchBusinessCanada() {
    var displayType = $("input:radio[name=DisplayType]:checked").val();
    //    var searchPrimary = $("input:checkbox[name=SearchPrimary]:checked").val();
    SearchBusinessCanada(displayType, false);
}

function StartSearchBusinessCanada2(tOmit) {
    var displayType = $("input:radio[name=DisplayType]:checked").val();
    //    var searchPrimary = $("input:checkbox[name=SearchPrimary]:checked").val();
    SearchBusinessCanada2(displayType, false, tOmit);
}

// search industry / business by text
function SearchBusinessCanada(type, searchPrimary) {
    var keyword = $('#BusinessSearchText').val();
    if (keyword == '') {
        $('#helpCallDiv').hide();
        $('#BusinessSearchResults').hide();
        $('#IndustrySearchResults').hide();
        return;
    }
    var searchType = $('#SearchType').val();
    $('#SearchText').val(keyword);
    $('#lnkIndustrySearch').hide();
    $('#divIndustrySearchLoadingimg').show();
    $.DotComAjax({
        url: "/CanadianBusiness/BusinessKeywordSearchItems?keyword=" + keyword + "&SearchType=" + searchType + "&DisplayType=" + type + "&primarySearch=" + searchPrimary,
        cache: true,
        success: function (data) {
            if (searchType == "BusinessName") {
                $('#helpCallDiv').hide();
                $('#BusinessSearchResults').html(data);
                $('#BusinessSearchResults').show();
                $('#IndustrySearchResults').hide();
            }
            else {
                $('#IndustrySearchResults').html(data);
                $('#IndustrySearchResults').show();
                $('#helpCallDiv').show();
                $('#BusinessSearchResults').hide();
            }
            ReapplySelections();
            $('#divIndustrySearchLoadingimg').hide();
            $('#lnkIndustrySearch').show();
            if (typeof success == 'function') {
                success();
            }
        },
        error: function () {
            context.find('img').attr('src', '/Images/Common/Exclamation.gif').attr('alt', 'Could not remove this selection');
            $('#divIndustrySearchLoadingimg').hide();
            $('#lnkIndustrySearch').show();
        },
        async: true
    });

}

// search industry / business by text
function SearchBusinessCanada2(type, searchPrimary, tOmit) {
    var keyword = $('#BusinessSearchText').val();
    if (keyword == '') {
        $('#helpCallDiv').hide();
        $('#BusinessSearchResults').hide();
        $('#IndustrySearchResults').hide();
        return;
    }
    var searchType = $('#SearchType').val();
    $('#SearchText').val(keyword);
    $('#lnkIndustrySearch').hide();
    $('#divIndustrySearchLoadingimg').show();
    $.DotComAjax({
        url: "/CanadianBusiness/BusinessKeywordSearchItems?keyword=" + keyword + "&SearchType=" + searchType + "&DisplayType=" + type + "&primarySearch=" + searchPrimary + "&tOmit=" + tOmit,
        cache: true,
        success: function (data) {
            if (searchType == "BusinessName") {
                $('#helpCallDiv').hide();
                $('#BusinessSearchResults').html(data);
                $('#BusinessSearchResults').show();
                $('#IndustrySearchResults').hide();
            }
            else {
                $('#IndustrySearchResults').html(data);
                $('#IndustrySearchResults').show();
                $('#helpCallDiv').show();
                $('#BusinessSearchResults').hide();
            }
            ReapplySelections();
            $('#divIndustrySearchLoadingimg').hide();
            $('#lnkIndustrySearch').show();
            if (typeof success == 'function') {
                success();
            }
        },
        error: function () {
            context.find('img').attr('src', '/Images/Common/Exclamation.gif').attr('alt', 'Could not remove this selection');
            $('#divIndustrySearchLoadingimg').hide();
            $('#lnkIndustrySearch').show();
        },
        async: true
    });

}

function ShowSelectedCodesCanada(evt) {
    FadeOutSections();
    SearchBusinessCanada($(evt).val());
}

function ToggleSearchCanada(search) {
    FadeOutSections();
    if (search == 'Business') {
        $('#DisplayCodesType').hide();
        $('#DisplayPrimarySearch').hide();
        $('#lnkBusiness').parent().removeClass('typeInactive');
        $('#lnkBusiness').parent().addClass('typeActive');
        $('#lnkIndustry').parent().removeClass('typeActive');
        $('#lnkIndustry').parent().addClass('typeInactive');
        $('#SearchType').val('BusinessName');
    }
    else {
        $('#DisplayCodesType').fadeIn('slow', function () { });
        $('#DisplayPrimarySearch').fadeIn('slow', function () { });
        $('#lnkBusiness').parent().removeClass('typeActive');
        $('#lnkBusiness').parent().addClass('typeInactive');
        $('#lnkIndustry').parent().removeClass('typeInactive');
        $('#lnkIndustry').parent().addClass('typeActive');
        $('#SearchType').val('IndustryType');
        $('#BusinessSearchCategoryRelated').show();
    }

    StartSearchBusinessCanada();
}

function ShowRelatedResultsCanada() {
    $('#ShowRelatedResults').val(true);
    var keyword = $('#BusinessSearchText').val();
    if (keyword == '') {
        $('#helpCallDiv').hide();
        $('#BusinessSearchResults').hide();
        $('#IndustrySearchResults').hide();
        return;
    }
    if ($('#lnkIndustryRelated').html() == "Hide related results") {
        $('#BusinessSearchCategoryRelated').hide();
        $('#lnkIndustryRelated').html("Show related results");
        return;
    }
    var searchType = $('#SearchType').val();
    var topKeys = $('#TopKeys').val();
    var type = $("input:radio[name=DisplayType]:checked").val();
    $('#SearchText').val(keyword);
    $('#divLoadingimg').show();
    $('#BusinessSearchCategoryRelated');
    $.DotComAjax({
        url: "/CanadianBusiness/BusinessKeywordSearchRelatedResults",
        cache: true,
        type: 'POST',
        data: { keyword: keyword, searchType: searchType, displayType: type, topKeys: topKeys },
        success: function (data) {
            $('#BusinessSearchCategoryRelated').html(data);
            $('#BusinessSearchCategoryRelated').show();
            $('#divLoadingimg').hide();
            ReapplySelections();
            $('#lnkIndustryRelated').html("Hide related results");
            if (typeof success == 'function') {
                success();
            }
        },
        error: function () {
            context.find('img').attr('src', '/Images/Common/Exclamation.gif').attr('alt', 'Could not remove this selection');
            $('#divLoadingimg').hide();
        },
        async: true
    });
}
